/* eslint-disable no-nested-ternary */
/* eslint-disable no-alert */
/* eslint-disable consistent-return */
import { apiGetModel, getApi } from '../../useApiHook';

export const getClinicianOptionsForOrgUnits = (auth, entityModel, forceReload, callback) => {
  // Prepare api model and request call
  const model = apiGetModel('GetCliniciansOptions', entityModel, forceReload, callback);
  getApi(auth, model);
};
